module.exports = __webpack_public_path__ + "media/images/map-icons/warning_icon@2x-bf0be4fde1217e05f2d8168849e5cc2d.png";